export default __webpack_public_path__ + "static/media/Manrope-ExtraBold.9228fb8d.ttf";